import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { filterCategories } from 'src/areas/landing-page/filter-categories';
import { NewProductRecommendationsFragment, Product } from 'src/types';
import ExpandableProductCardGrid from '../expandable-product-card-grid';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

type Props = {
  newReleases?: Recommendations['newReleases'];
};

type Recommendations = NonNullable<
  NewProductRecommendationsFragment['newProductRecommendations']
>;

const NewProductReleases: React.FC<Props> = props => {
  const { newReleases: newProducts = { nodes: [] } } = props;
  const { t } = useContext(AppContext);

  if (!(newProducts && newProducts.nodes) || !newProducts.nodes.length) {
    return null;
  }

  const newProductsItems = filterCategories(newProducts.nodes as Product[]);

  const trackHeaderClick = (data: { link: string }) => {
    trackInternalNavigationClick({
      scope: InternalNavigationScope.NEW_PRODUCT_RELEASES_HEADER,
      nextPage: data.link,
    });
  };

  const trackProductCardClick = (data: { index: number; link: string }) => {
    trackInternalNavigationClick({
      scope: InternalNavigationScope.NEW_PRODUCT_RELEASES_PRODUCT_CARD,
      nextPage: data.link,
      index: data.index,
    });
  };

  return (
    <ExpandableProductCardGrid
      products={newProductsItems}
      title={t('landing', 'personalized-releases.title')}
      shouldLazyLoadImages
      onHeaderLinkClick={trackHeaderClick}
      onProductCardClick={trackProductCardClick}
    />
  );
};

export default NewProductReleases;
